// extracted by mini-css-extract-plugin
export var section = "Section-module--section--t2Kke";
export var bg_white = "Section-module--bg_white--K-nBF";
export var bg_light = "Section-module--bg_light--kwwQL";
export var bg_dark = "Section-module--bg_dark--vZSrp";